export default function Footer() {
  const services = [
    'Fabrika Catering',
    'Şantiye Catering',
    'Kurumsal Catering',
    'Okul & Kurum',
    'Film & Dizi Setleri',
    'Organizasyon Catering',
  ];

  return (
    <footer className="bg-accent-950 py-12 md:py-16 border-t border-accent-900/50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mb-10">
          <div>
            <span className="font-heading text-2xl md:text-3xl text-primary-400 tracking-wider">
              KAYA CATERING
            </span>
            <p className="font-body text-background-400 text-sm mt-3 leading-relaxed">
              Toplu Yemek &amp; Catering Hizmetleri
            </p>
          </div>
          <div>
            <h4 className="font-heading text-lg text-background-100 mb-4">Hizmetler</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <span className="font-body text-background-400 text-sm hover:text-primary-400 transition-colors cursor-default">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-lg text-background-100 mb-4">İletişim</h4>
            <p className="font-label text-background-400 text-sm mb-3">
              <i className="ri-phone-line mr-2 text-primary-500"></i>
              0542 776 2227
            </p>
            <div className="flex gap-4 mt-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-800/50 border border-accent-700 text-background-300 hover:text-primary-400 hover:border-primary-400/50 transition-all"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-800/50 border border-accent-700 text-background-300 hover:text-primary-400 hover:border-primary-400/50 transition-all"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-accent-900/50 text-center">
          <p className="font-label text-background-500 text-xs">
            Kaya Catering. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
}